import React from 'react'
import "./css/index.css";


function UnderDevelopment() {
  return (
    <div className="container">
    <div>
     <h1>Page is Under Development</h1> 
    </div>
  </div>
  )
}

export default UnderDevelopment